import { ImportExportService } from './core/services/import-export.service';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';

import { TranslateModule } from '@ngx-translate/core';

import { TbAuthModule, TbAuthInterceptor } from '@tb/auth';

import { environment } from 'src/environments/environment';

import { AppRoutingModule } from './app.routing';

import { AppComponent } from './app/app.component';

import { CoreModule } from './core/core.module';
import { SharedModule, TRANSLATE_MODULE_CONFIG } from './shared/shared.module';

import { AppInitService } from './core/services/app-init.service';
import { AlertDialogComponent } from './store/dialogs/alert-dialog/alert-dialog.component';
import { YesNoDialogComponent } from './store/dialogs/yes-no-dialog/yes-no-dialog.component';
import { InputDialogComponent } from './store/dialogs/input-dialog/input-dialog.component';
import { RolesSelectorComponent } from './portal/account-console-test/roles-selector/roles-selector.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MatStepperModule } from '@angular/material/stepper';
import { MatIconModule } from '@angular/material/icon';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { ListSelectorComponent } from './portal/account-console-test/list-selector/list-selector.component';
import { LoginService } from './core/services/login.service';
import { ModelService } from './core/services/model.service';
import { ComponentCommunicationService } from './core/services/component-communication.service';
import { RolesService } from './core/services/roles.service';
import { StoreRolesService } from './core/services/store-role.service';
import { AuthenticatorService } from './core/services/authenticator.service';
import { PasskeyotpViewComponent } from './portal/technical-support/passkeyotp-view/passkeyotp-view.component';
import {
    MAT_MOMENT_DATE_FORMATS,
    MomentDateAdapter,
    MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { PortalModule } from "./portal/portal.module";

// required by ngx-translate library
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

export function initializeApp(appInitService: AppInitService) {
    return (): Promise<any> => {
        return appInitService.Init();
    };
}

@NgModule({
    declarations: [
        AppComponent,
        AlertDialogComponent,
        YesNoDialogComponent,
        InputDialogComponent,
        RolesSelectorComponent,
        ListSelectorComponent,
        PasskeyotpViewComponent
    ],
    imports: [
      // angular
      BrowserAnimationsModule,
      BrowserModule,
      // core & shared
      CoreModule,
      SharedModule,
      TranslateModule.forRoot(TRANSLATE_MODULE_CONFIG),
      AppRoutingModule,
      MatStepperModule,
      MatIconModule,
      TbAuthModule.forRoot(),
      PortalModule
    ],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'it-IT' },
        { provide: HTTP_INTERCEPTORS, useClass: TbAuthInterceptor, multi: true },
        {
            provide: 'env',
            useValue: environment,
        },
        {
            provide: STEPPER_GLOBAL_OPTIONS,
            useValue: { displayDefaultIndicatorType: false },
        },

        AppInitService,
        {
            provide: APP_INITIALIZER,
            useFactory: initializeApp,
            deps: [AppInitService],
            multi: true,
        },
        LoginService,
        ModelService,
        ComponentCommunicationService,
        RolesService,
        StoreRolesService,
        ImportExportService,
        AuthenticatorService,
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
